import { ActionFactoryParams } from '../../../../utilsDeprecated/ControlledComponent/ControlledComponent.types';
import { CalendarStateDeprecated } from '../../controller';
import { CalendarContext } from '../../../../utilsDeprecated/context/contextFactory';
import { FlowElements } from '../../Hooks/useFlow';
import { BASE_DELAY } from '../../../../constants/constants';

export type SetFocusedElement = (flowElement: FlowElements) => void;

export function createSetFocusedElementAction({
  getControllerState,
}: ActionFactoryParams<CalendarStateDeprecated, CalendarContext>): SetFocusedElement {
  return (flowElement) => {
    const [, setState] = getControllerState();
    setState({
      focusedElement: flowElement,
    });

    setTimeout(
      () =>
        setState({
          focusedElement: undefined,
        }),
      BASE_DELAY,
    );
  };
}
